export class ModelParameter{
  parameterId: number;
  parameterName: string;
  parameterDefaultValue: any;
  parameterDataType: string;
  parameterUom: string;
  captionName: string;
  uomType: string;

  constructor() {
    this.parameterId = 0;
    this.parameterName = '';
    this.parameterDefaultValue = null;
    this.parameterDataType = '';
    this.parameterUom = '';
    this.captionName = '';
    this.uomType = '';
  }
}

export enum DataSrc {
  model = 0,
  user = 1,
  extDataSrc = 2
}
